import Link from 'next/link';

const BreadCrumbs = () => {
  return (
    <>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item home--icon" aria-current="page">
            Home
          </li>
        </ol>
      </nav>

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link href="/" legacyBehavior>
              <a className="home--icon">Home</a>
            </Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Library
          </li>
        </ol>
      </nav>

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link href="/" legacyBehavior>
              <a className="home--icon">Home</a>
            </Link>
          </li>
          <li className="breadcrumb-item">
            <Link href="#" legacyBehavior>
              <a>Library</a>
            </Link>
          </li>
          <li className="breadcrumb-item">
            <Link href="#" legacyBehavior>
              <a>Lorem ipsum</a>
            </Link>
          </li>
          <li className="breadcrumb-item">
            <Link href="#" legacyBehavior>
              <a>Dolor sit amet</a>
            </Link>
          </li>
          <li className="breadcrumb-item">
            <Link href="#" legacyBehavior>
              <a>Lorem, ipsum dolor.</a>
            </Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Data
          </li>
        </ol>
      </nav>
    </>
  );
};

export default BreadCrumbs;
